import { render, staticRenderFns } from "./PhIcon.vue?vue&type=template&id=188cd125&scoped=true&"
import script from "./PhIcon.vue?vue&type=script&lang=js&"
export * from "./PhIcon.vue?vue&type=script&lang=js&"
import style0 from "./PhIcon.vue?vue&type=style&index=0&id=188cd125&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188cd125",
  null
  
)

export default component.exports